import React from "react";
import ReactDOM from "react-dom/client";
import WaMiningSovereign from "./wa-mining-sovereign-software";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <WaMiningSovereign />
  </React.StrictMode>,
);
